import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import {IconButton, InputBase} from '@mui/material'
import PropTypes from 'prop-types'
import React, {useEffect, useState} from 'react'
import { useDefaultComponentTools } from '../hooks/useDefaultComponentTools'


const AppSearch = ({
	onUserInput,
	inputSx,
	placeholder
}) => {
	const { theme } = useDefaultComponentTools()
	const [searchValue, setSearchValue] = useState('')
	const handleChange = e => {
		setSearchValue(e.target.value)
	}
	const onRefresh = () => {
		setSearchValue('')
	}
	useEffect(() => {
		onUserInput(searchValue)
	}, [searchValue])

	return (
		<InputBase
			type={'text'}
			value={searchValue}
			onChange={handleChange}
			sx={{ '& .MuiInputBase-input': {ml: '10px'},
				background: theme.palette.second, borderRadius: '4px',
				color: theme.palette.text.secondary, fontSize: '12px', height: '40px', p: '14px',
				...inputSx
			}}
			placeholder={placeholder}
			startAdornment={
				<SearchIcon fontSize='small' color={theme.palette.text.secondary}/>}
			endAdornment={
				<IconButton
					sx={{color: theme.palette.text.secondary}}
					aria-label='close'
					onClick={onRefresh}
				>
					<CloseIcon fontSize='small'/>
				</IconButton>
			}
		/>
	)
}

AppSearch.propTypes = {
	inputSx: PropTypes.object,
	onUserInput: PropTypes.func,
	placeholder: PropTypes.string
}

export default AppSearch
